import { render, staticRenderFns } from "./ProductionProcess.vue?vue&type=template&id=5c6d07d3&scoped=true&"
import script from "./ProductionProcess.vue?vue&type=script&lang=js&"
export * from "./ProductionProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6d07d3",
  null
  
)

export default component.exports